<template>
    <a :href="urlWishList" class="nav-link position-relative" rel="nofollow" :aria-label="$translate('Ceres::Template.wishList')">
      <svg width="32" height="32">
        <title>{{ $translate("Stoffe::Template.headerWishList") }}</title>
        <desc>{{ $translate("Stoffe::Template.headerWishListDesc") }}</desc>
        <path d="M15.99218,27.87529l-9.3457-9.94824c-2.72949-3.05176-2.73438-7.98438-.02783-11.0127,1.34473-1.50391,3.1416-2.33203,5.05957-2.33203,1.58545,0,3.0874.56543,4.31982,1.61133,1.2334-1.0459,2.73584-1.61133,4.3208-1.61133,1.91699,0,3.71338.82812,5.05811,2.33105,2.67334,2.99121,2.71387,7.90723.09082,10.95898l-9.47559,10.00293ZM11.67822,6.58232c-1.34131,0-2.6084.59082-3.56836,1.66504-2.0498,2.29297-2.04443,6.0293.01123,8.32812l7.87695,8.38574,7.98535-8.42773c1.96045-2.2832,1.93164-6.0166-.09717-8.28711-.95996-1.07324-2.22705-1.66406-3.56738-1.66406-1.31934,0-2.56787.57227-3.52246,1.61426l-.54541.81836-1.04736-.81445c-.95459-1.04395-2.2041-1.61816-3.52539-1.61816Z" style="fill: #303239; stroke-width: 0px;"></path>
      </svg>
      <span class="badge-counter">{{ wishListCount }}</span>
    </a>
</template>

<script>
export default {
    computed:
    {
        wishListCount()
        {
            return this.$store.getters.wishListCount;
        },

        urlWishList()
        {
            return App.urls.wishList;
        }
    }
}
</script>
